<script>
import ValidatorMixin from '../../mixins/validatorMixin';
import TwConfirmDialog from '../../components/TwConfirmDialog';

export default {
  name: 'ItineraryCreate',
  components: {
    TwConfirmDialog,
  },
  props: {
    name: {
      type: String,
      default: null,
    },
    productTypeId: {
      type: Number,
      default: null,
    },
    productTypes: {
      type: Array,
      required: true,
    },
    createLoading: {
      type: Boolean,
      default: false,
    },
    createError: {
      type: [Boolean, String],
      default: false,
    },
  },
  data() {
    return {
      itineraryName: null,
      itineraryProductTypeId: null,
      isExtension: false,
      valid: true,
      toggled: true,
      error: false,
      input: null,
    };
  },
  methods: {
    confirm() {
      this.$emit('confirm', {
        name: this.itineraryName,
        productTypeId: this.itineraryProductTypeId,
        isExtension: this.isExtension,
      });
    },
    cancel() {
      this.$emit('cancel');
    },
    cancelDialog() {
      if (this.input === 'itineraryProductTypeId') {
        this.itineraryProductTypeId = null;
      }
    },
    toggleDialog(input) {
      this.input = input;
      setTimeout(() => {
        this.$refs.dialog.open();
      }, 500);
    },
  },
  created() {
    this.itineraryName = this.name;
    this.itineraryProductTypeId = this.productTypeId;
  },
  computed: {
    isProductMaster() {
      if (!this.itineraryProductTypeId) {
        return false;
      }
      return this.productTypes.find(productType => productType.id === this.itineraryProductTypeId).isProductMaster;
    },
  },
  watch: {
    toggled(value) {
      // Ensure that outside click triggers cancel event
      if (value === false) {
        this.cancel();
      }
    },
    createError(value) {
      this.error = value;
    },
  },
  mixins: [ValidatorMixin],
};
</script>

<template>
  <v-dialog
    v-model="toggled"
    max-width="800px">
    <v-card>
      <v-flex font-weight-bold pa-3 title>
        <v-icon>edit</v-icon>
        {{ $t('itinerary.create.title') }}
      </v-flex>
      <v-divider/>
        <v-alert
          :value="error"
          type="error"
        >
          <v-flex class="justify-center">
            {{ $t(createError) }}
          </v-flex>
        </v-alert>
      <v-flex pa-4>
        {{ $t('itinerary.create.description') }}
      </v-flex>
      <v-form
        v-model="valid"
        ref="form">
        <v-flex pa-4>
          <v-text-field
            v-model="itineraryName"
            clearable
            :rules="[rules.required]"
            :label="$t('itinerary.create.name')"
            :loading="createLoading"/>
          <v-select
            v-model="itineraryProductTypeId"
            value="id"
            item-text="name"
            item-value="id"
            clearable
            clear-icon="clear"
            :disabled="isExtension"
            :label="$t('itinerary.create.productType')"
            :rules="[rules.required]"
            :items="productTypes"
            :loading="createLoading"
            @change="toggleDialog('itineraryProductTypeId')"/>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-checkbox
                v-model="isExtension"
                v-on="on"
                :disabled="createLoading || !isProductMaster"
                :label="$t('itinerary.create.extension')"/>
            </template>
            <span>{{ $t('itinerary.create.tooltips.extension') }}</span>
          </v-tooltip>
        </v-flex>
        <v-divider/>
        <v-spacer/>
        <v-layout justify-end>
          <v-btn
            color="red darken-1"
            flat
            @click="cancel">
            {{ $t('dialog.actions.cancel') }}
          </v-btn>
          <v-btn
            color="primary darken-1"
            flat
            :disabled="!valid"
            :loading="createLoading"
            @click="confirm">
            {{ $t('dialog.actions.save') }}
          </v-btn>
        </v-layout>
      </v-form>
    </v-card>
    <tw-confirm-dialog
      ref="dialog"
      :title="$t('dialog.confirm.title')"
      :description="$t('dialog.confirm.text')"
      @cancel="cancelDialog"
    />
  </v-dialog>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryOverviewCreate.vue